import {IContextLookupValue} from 'modules/context/context-types';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {IRisksRequestDetailsDto, IRisksRequestsResponse, IUpdateActiveArgs, ISendServiceArgs} from './types';

const RISKS_REQUESTS_ROUTE = 'ais3.risks.requests';

export interface IGetRisksRequestsArgs {
    paginationPageSize?: number;
    paginationCurrent?: number;
    organizationId?: IContextLookupValue;
}

const getData = (args?: IGetRisksRequestsArgs) =>
    performRequest<IRisksRequestsResponse>({
        url: RISKS_REQUESTS_ROUTE,
        method: ERequestType.GET,
        params: {
            paginationPageSize: args?.paginationPageSize,
            paginationCurrent: args?.paginationCurrent,
            organizationId: args?.organizationId?.id,
        },
    });

const getById = (id: number) =>
    performRequest<IRisksRequestDetailsDto>({url: `${RISKS_REQUESTS_ROUTE}/${id}`, method: ERequestType.GET});

const refreshRequest = (id: number) =>
    performRequest<string>({url: `${RISKS_REQUESTS_ROUTE}/${id}/refresh`, method: ERequestType.POST});

const updateDocsActive = (args: IUpdateActiveArgs) =>
    performRequest<string>({
        url: `${RISKS_REQUESTS_ROUTE}/risk-info-docs/active`,
        data: args,
        method: ERequestType.POST,
    });

const sendService = (args: ISendServiceArgs) => {
    const formData = new FormData();

    formData.append('externalServiceId', String(args.externalServiceId));
    formData.append('requestId', String(args.requestNumber));

    return performRequest<string>({
        url: `/integration.module/monitor.services/execute`,
        data: formData,
        method: ERequestType.POST,
        headers: {'Content-Type': 'multipart/form-data'},
    });
};

export const RisksRequestsApi = {getData, getById, refreshRequest, updateDocsActive, sendService};
